import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">影视大全</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按类型浏览海量高清影视资源，涵盖全品类电影大全
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href={item.link}
              className="flex flex-col items-center p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300/40 hover:bg-accent-50/30 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl bg-accent-100 group-hover:bg-accent-200 transition-colors mb-3">
                <i className={`${item.icon} text-accent-600 text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-600 transition-colors whitespace-nowrap">
                {item.title}
              </span>
              <span className="text-xs text-foreground-400 mt-1">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}